module.exports = __webpack_public_path__ + "static/favicon-2f41085307c8866b6cbd9c787eb47928.png";